module.exports = __webpack_public_path__ + "static/media/360-3.3798772e.webp";